import React, { forwardRef } from 'react';

import TextField from '@material-ui/core/TextField';

function applyTeclaMask(value) {
  const raw = String(value || '')
    .replace(/-/g, '')
    .slice(0, 4);
  if (raw.length <= 2) return raw;
  return `${raw.slice(0, 2)}-${raw.slice(2)}`;
}

export const TeclaInput = forwardRef(
  (
    {
      value,
      onChange,
      handleEnter = () => {},
      handleKey = () => {},
      fullWidth,
      disabled = false,
      error = false,
      helperText = '',
      ...rest
    },
    forwardedRef,
  ) => {
    const handleChange = (e) => {
      const masked = applyTeclaMask(e.target.value);
      onChange({ ...e, target: { ...e.target, value: masked } });
    };

    return (
      <TextField
        margin="normal"
        {...rest}
        value={applyTeclaMask(value)}
        onChange={handleChange}
        disabled={disabled}
        error={error}
        helperText={helperText}
        inputRef={forwardedRef}
        onKeyDown={(e) => {
          if (e.keyCode === 13) handleEnter();
          else handleKey(e.keyCode, e.key);
        }}
        type="text"
        variant="outlined"
        fullWidth={fullWidth}
        inputProps={{ maxLength: 5 }}
      />
    );
  },
);

export default TeclaInput;
